var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("奏 ―kanade")]),_c('v-card-subtitle',[_vm._v("聴く DMV")]),_c('hover-link-card',{attrs:{"title":"","subtitle":"","to":"/mypage/kanade/random"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }